import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Nav from './Nav';
const useStyle = makeStyles((theme) => ({
  main: {
    padding: "30px",
  },

  container: {
    boxShadow: " 0 5px 15px rgba(0, 0, 0, 0.2)",

    padding: "15px",
    marginBottom: "20px",
  },
  image: {
    height: "200px",
    width: "250px",
  },
  datelogo: {
    paddingTop: "18px",
    height: "20px",
    width: "20px",
  },

  button: {
    textTransform: "lowercase",
  },
  datebutton: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "15px",
  },

  videoTitle: {
    color: "hsl(205,78%,33%)",
  },
}));

const News = () => {
  const classes = useStyle();
  return (
    <><div className={classes.main}>
      <Nav></Nav>
      <div>
        <Typography
          variant="h5"
          style={{
            color: "hsl(205,78%,33%)",
            display: "flex",
            justifyContent: "center",
            margin: "2% 0",
          }}
        >
          Articles
        </Typography>

        <p
          style={{
            marginTop: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          MOT members are actively engaged in different activities,This page
          shows the different MOT realted Articles and standard operating
          proposals.
        </p>
      </div>
      <div className={classes.cards}>
        <Grid className={classes.container}>
          <div className={classes.videoTitle}>
            <Typography variant="h6">biotechnologysocietyofnepal </Typography>
          </div>
          <Typography variant="p" color="textSecondary">
          Our team, the Biotechnology Society of Nepal (BSN), Robotic Association of Nepal (RAN), mission oxygen team 
          (MOT), and UNDP, Devdaha medical college, and research institute are running training on the handling,  
          maintenance, and use of biomedical equipment for biomedical engineers and other technical experts in this 
          field at Devdaha medical college located at butwal wonderful city of Nepal.
          We currently complete our first two days. Looking forward to interacting with all the Biomedical engineers.
          Mission Oxygen Team[MOT] is providing hands-on training on biomedical equipment to biomedical Engineers in
           support of UNDP. MOT brings its  training for the biomedical engineers of Butwal from Lumbini Province. With motive of “Strengthening Health System through Trained Biomedical Engineers”. Basically our training is for 5 days in which we will provide training on one day general training and two-two days on ICU Equipment, OT Equipment, and their safety measures. 
          </Typography>

          <div className={classes.datebutton}>
            <p style={{ fontSize: ".85rem" }}> 22 Aug 2022</p>
            {/* <Button
              startIcon={
                <img
                  src="https://img.icons8.com/small/32/000000/download.png"
                  alt="logo"
                  style={{ height: "16px", margin: 0 }}
                />
              }
              variant="text"
              color="primary"
              className={classes.button}
            >
              Download pdf.
            </Button> */}
          </div>
        </Grid>

        <Grid className={classes.container}>
          <div className={classes.videoTitle}>
            <Typography variant="h6">1 day ventilator training</Typography>
          </div>
          <Typography variant="p" color="textSecondary">
          Wonderful session of 1 day ventilator training for the medical engineers working 
          in different hospitals of Butwal. Ventilators are the key medical devices and are
           the most needed machine in ICU and Operation theater. If you don’t know the basic 
           of these devices you cannot repair or maintain these life saving machine. Today I 
           was privileged to share my knowledge to these wonderful hard working engineers who 
           are continuously working for their community hospitals and private institutions. I
            hope my small support will help them to do more in this field. And I also hope they 
            have a Learned few new things on ventilator.
          </Typography>
          <div className={classes.datebutton}>
            <p style={{ fontSize: ".85rem" }}> 24 Aug 2022</p>
            {/* <Button
              startIcon={
                <img
                  src="https://img.icons8.com/small/32/000000/download.png"
                  alt="logo"
                  style={{ height: "16px", color: "hsl(205,78%,35%)" }}
                />
              }
              variant="text"
              color="primary"
              className={classes.button}
            >
              Download pdf.
            </Button> */}
          </div>
        </Grid>
        <Grid className={classes.container}>
          <div className={classes.videoTitle}>
            <Typography variant="h6">The Asiia Foundation</Typography>
          </div>
          <Typography variant="p" color="textSecondary">
          The work which introduces you in the world of the competition and the partner 
          which supports you in every prior condition either in your downfall or upliftment
           is the best achievement. MOT will always be thankful to  The Asia Foundation for 
           always supporting us and keep supporting us in the same manner so built a strong 
           support system for biomedical equipment and its necessities. We would also like 
           to thank Mrs. Sajana Maharjan Amatya, Mr. Pranay Sthapit and the entire The Asia Foundation family.
          </Typography>
          <div className={classes.datebutton}>
            <p style={{ fontSize: ".85rem" }}> 6 July 2022</p>
            {/* <Button
              startIcon={
                <img
                  src="https://img.icons8.com/small/32/000000/download.png"
                  alt="logo"
                  style={{ height: "16px", color: "hsl(205,78%,35%)" }}
                />
              }
              variant="text"
              color="primary"
              className={classes.button}
            >
              Download pdf.
            </Button> */}
          </div>
        </Grid>
      </div>
    </div>
    </>
  );
};

export default News;
